import React from "react";
import { Link } from "react-router-dom";

const Care: React.FC = () => (
  <div className="centered-section">
    <h2>Knife Care: The Rant</h2>
    <p>
      Never, ever put your knife in the dishwasher! The harsh detergents, high heat, and jostling will ruin the edge, damage the handle, and shorten the life of your knife. Always hand wash your knives with mild soap and water, dry them immediately, and store them safely. 
    </p>
    <p>
      Treat your knives with respect: use a proper cutting board (no glass, stone, or metal), avoid twisting or prying, and keep them sharp. A well-cared-for knife will last a lifetime and make every meal prep safer and more enjoyable.
    </p>
    <p>
      <strong>Remember:</strong> A dishwasher is a knife's worst enemy. Take the extra minute to wash by hand after use. You (and your knives) will be glad you did!
    </p>
  <Link to="/" className="main-link">&#8592; Back to Main Page</Link>
  </div>
);

export default Care;
